import { render, staticRenderFns } from "./DemFormConfiguration.vue?vue&type=template&id=da1dab84&scoped=true&lang=pug"
import script from "./DemFormConfiguration.vue?vue&type=script&lang=js"
export * from "./DemFormConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DemFormConfiguration.vue?vue&type=style&index=0&id=da1dab84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1dab84",
  null
  
)

export default component.exports